import { classNameGenerator } from "@/utils";
import { useState } from "react";

import styles from "./style.module.scss";
import { Button } from "@/components/Atoms";
import * as actions from "@/redux/ShyftPassReducer";
import { useAppDispatch, useAppSelector } from "@/hooks";

interface ZoneButtonGroupProps {
  zoneList: {
    id: number;
    name: string;
  }[];
}

const ZoneButtonGroup: React.FC<ZoneButtonGroupProps> = ({ zoneList }) => {
  const dispatch = useAppDispatch();
  const { selectedShyftPassZoneId } = useAppSelector(
    (state) => state.shyftPass
  );

  let search = "";
  if (typeof window !== "undefined") {
    search = document?.location?.search;
  }

  const params = new URLSearchParams(search);
  const encodedId = params?.get("encoded_id") || "";
  const onboardId = params?.get("onboard_id") || "";

  const { selectedDate } = useAppSelector((state) => state.shyftPass);

  const buttonClickHandler = (zoneId: number) => {
    if (zoneId === selectedShyftPassZoneId) {
      return;
    }
    dispatch(actions.setShyftPassZoneId({ zoneId }));
    dispatch(
      actions.getShyftPassScheduleData({
        zoneId: zoneId,
        startDate: selectedDate,
      })
    );
  };

  const cls = classNameGenerator(styles);

  return (
    <div className={cls("ZoneButtonGroup")}>
      {zoneList?.map(({ id, name }, index) => {
        const isSelected = selectedShyftPassZoneId === id;
        const isLeftButton = index === 0;
        const isRightButton = index === zoneList.length - 1;
        const isOuterButton = index === 0 || index === zoneList.length - 1;
        return (
          <Button
            variant={"primary1"}
            bgColor={isSelected ? "#6941C6" : "#ffffff"}
            hoverColor="none"
            borderRadius={
              isOuterButton
                ? isLeftButton
                  ? "8px 0px 0px 8px"
                  : "0px 8px 8px 0px"
                : "0px"
            }
            btnPadding={isOuterButton ? "11px 32px" : "11px 16px 11px 16px"}
            borderColor={isSelected ? "" : "#7950D4"}
            onClick={() => {
              buttonClickHandler(id);
            }}
            className={isSelected ? "buttonStyleSelected" : "buttonStyle"}
          >
            {name}
          </Button>
        );
      })}
    </div>
  );
};

export default ZoneButtonGroup;
